import { PopoverPanel as HeadlessPopoverPanel, PopoverPanelProps } from "@headlessui/react";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export const PopoverPanel: FC<PopoverPanelProps> = ({ className: classNameProp, ...props }) => {
  const defaultClasses =
    "z-[3] rounded-lg border-none bg-black-tint-99 p-2 text-sm font-normal shadow-level-3";
  const className =
    typeof classNameProp === "function"
      ? (bag) => twMerge(defaultClasses, classNameProp(bag))
      : twMerge(defaultClasses, classNameProp);
  return <HeadlessPopoverPanel className={className} {...props} />;
};
PopoverPanel.displayName = "PopoverPanel";

export { Popover, PopoverButton } from "@headlessui/react";
export type { PopoverProps, PopoverButtonProps, PopoverPanelProps } from "@headlessui/react";
